// The axios singleton with this app's wire-format default applied. Import axios from here, not from 'axios', so the
// query serialization (see legacyParams.js) does not depend on which module happened to load first.
import axios from 'axios';
import { serializeParams } from './legacyParams';

axios.defaults.paramsSerializer = { serialize: serializeParams };

export default axios;
